<div class="backModal enCalendar">
    <div class="close closeModal">
      <a (click)="cancelar()" title="cerrar"><span class="cross"></span><span class="sr-only">cerrar</span></a>
    </div>
    <div class="aviso">
      <div class="tituloSearch">
        {{ 'MENSAJE_CONFIRMAR_VENTA_RESERVA' | translateV2}}
      </div>
      <div class="faturacion-fila">
        <div class="ticket-info">
          <div class="inputControl botones">
            <!-- <button type="button" value="cancelar" class="cancelar" (click)="cancelar()">CANCELAR</button> -->
            <button type="button" value="cancelar" class="cancelar" (click)="abriradminOnline()">
              {{ 'IR_ADMINISTRACION' | translateV2 }}
            </button>
          </div>
        </div>
        <div class="ticket-info">
          <div class="inputControl botones">
            <button type="button" value="ACEPTAR" class="pagar aceptar" (click)="confirmar()">
              {{ 'ACEPTAR' | translateV2 }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <form #formadmin id="AdminForm" method="post" [action]="this.urladmin" target="Admin"> 
      <input type="hidden"  name="hdargumentos" value="something"/>
    </form>
  </div>